import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { header3kx6g3yb4df1r as header } from '../../../../../ktor-ktor-client-core/io/ktor/client/request/utils.mjs';
import { Companion_getInstance1bxbth0yni76u as Companion_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import { defaultRequest2ux1d5xxixv6z as defaultRequest } from '../../../../../ktor-ktor-client-core/io/ktor/client/plugins/DefaultRequest.mjs';
import { HttpClienthpouyso1j6ge as HttpClient } from '../../../../../ktor-ktor-client-core/io/ktor/client/HttpClient.mjs';
import { HttpClient3584jcajl7sef as HttpClient_0 } from '../../../../../ktor-ktor-client-core/io/ktor/client/HttpClient.web.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function defaultClient(hostUrl, traceId, engine) {
  traceId = traceId === VOID ? null : traceId;
  engine = engine === VOID ? null : engine;
  return buildClient(engine, ($this$buildClient) => {
    $this$buildClient.l5i_1 = false;
    defaultRequest($this$buildClient, ($this$defaultRequest) => {
      header($this$defaultRequest, 'User-Agent', 'CouplingSdk');
      var tmp0_elvis_lhs = traceId;
      header($this$defaultRequest, 'X-Request-ID', tmp0_elvis_lhs == null ? Companion_getInstance().ht() : tmp0_elvis_lhs);
      $this$defaultRequest.s5o(hostUrl);
      return Unit_instance;
    });
    return Unit_instance;
  });
}
function buildClient(engine, block) {
  engine = engine === VOID ? null : engine;
  var tmp;
  if (engine == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = HttpClient(engine, block);
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? HttpClient_0(block) : tmp1_elvis_lhs;
}
//region block: exports
export {
  defaultClient as defaultClient32xevb6g4ofep,
};
//endregion

//# sourceMappingURL=KtorSyntax.mjs.map
